import React, {useEffect, useRef, useState} from "react";
import { useMediaQuery } from 'react-responsive';
import TalentSideMenu from "../../components/TalentSideMenu";
import ChatList from "./components/ChatList";
import ChatBox from "./components/ChatBox";
import TalentHeader from "components/TalentHeader";
import {useDispatch, useSelector} from "react-redux";
import { MOBILE_SCREEN_WIDTH } from "../../constants/index";
import {
  getListChatTalent, setPageSize, setIsSameChatSelected, 
  getListJobRecommendTalent, setIsNewTalentConversation,
  setChatSelected,
  setIsChatting,
  setIsScout,
  setJobSelected,
  setMessages,
  getNumberMessagesTalent,
  getTalentMessages,
  setStaffSelected,
  setChatList,
  setOpenChatListModal,
  setIsNewChatFormOtherScreen,
  setPage, setIsPaging, setLoadingGetListChat,
  setIsOpenListJobPanel, setActionItems,
} from "reducers/chatMessage";
import {ThunkDispatch} from "@reduxjs/toolkit";
import ChatListModal from "./components/ChatListModal";
import CustomButton from "../../components/CustomButton";
import Copyright from "../../components/Copyright";

const TalentChat = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const isMobile = useMediaQuery({ maxWidth: MOBILE_SCREEN_WIDTH });
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  let {talentInfo} = useSelector((state: any) => state.currentUser)

  const { chatList, chatSelected, isChatting, actionStatus, actionName, isOpenChatListModal,
    isNewChatFormOtherScreen, page, pageSize, totalCons, isSameChatSelected, messages, isPaging,
    isLoadNewListChat, loadingGetListChat, isNewTalentConversation } = useSelector((state: any) => state.chatMessage);
  const divRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (isMobile && isNewChatFormOtherScreen) {
      dispatch(setOpenChatListModal(false));
    } else {
      dispatch(setOpenChatListModal(true));
    }

    setIsFirstLoad(true)

    dispatch(setPage(1));
    dispatch(setPageSize(15));

    // Get list job recommend
    const data = { search: '' }
    dispatch(getListJobRecommendTalent(data));
    return () => {
      dispatch(setIsChatting(false));
      dispatch(setChatSelected({}));
      dispatch(setIsNewChatFormOtherScreen(false));
    }
  }, []);

  useEffect(() => {
    if(isLoadNewListChat) {
      // Get options related talent
      dispatch(setLoadingGetListChat(true))
      dispatch(setIsPaging(false))
      dispatch(getListChatTalent({page: 1, pageSize: 15}));
    }
  }, [isLoadNewListChat]);

  useEffect(() => {
    const handleScroll = () => {
      if(page * pageSize >= totalCons) {
        return
      }
      
      if (divRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = divRef.current;
        if (scrollTop + clientHeight + 300 >= scrollHeight) {
          dispatch(setIsPaging(true))
          const nextPage = page + 1
          dispatch(setLoadingGetListChat(true))
          dispatch(getListChatTalent({page: nextPage, pageSize: pageSize}));
          dispatch(setPage(nextPage))
        }
      }
    };

    const divElement = divRef.current;
    divElement?.addEventListener("scroll", handleScroll);

    return () => divElement?.removeEventListener("scroll", handleScroll);
  }, [page, chatList, isLoadNewListChat]);


  // Show toast
  useEffect(() => {
    if (actionStatus === 'fulfilled') {
      switch(actionName) {
          case 'talentSendMessage':
            dispatch(setLoadingGetListChat(true))
            dispatch(setIsPaging(false))
            dispatch(getListChatTalent({page: 1, pageSize: page * pageSize}));
            dispatch(setIsNewChatFormOtherScreen(false));
            setIsFirstLoad(true)
            break;
          case 'getListChatTalent':
            if(
              (chatList?.length > 0 && !isNewChatFormOtherScreen && isSameChatSelected && chatSelected?.id) ||
              (chatList?.length > 0 && isNewTalentConversation && !chatSelected?.id)
            ) {
              dispatch(setJobSelected({}));
              dispatch(setChatSelected({}));
              dispatch(setStaffSelected({}));
              handleSelectConvention(chatList[0]);

              dispatch(setIsNewTalentConversation(false));
            }
            setIsFirstLoad(false)
            dispatch(setIsNewChatFormOtherScreen(false));
            break;
          case 'getTalentMessages':
            dispatch(getNumberMessagesTalent(""));
            break;
          case 'updateTalentConventionJob':
            dispatch(setLoadingGetListChat(true))
            dispatch(setIsSameChatSelected(false))
            dispatch(setIsPaging(false))
            dispatch(getListChatTalent({page: 1, pageSize: page * pageSize}));
            break;
          default:
            break;
        }
    }
  }, [actionStatus, actionName, isSameChatSelected, messages, isOpenChatListModal]);

  const handleCloseChatBox = () => {
    dispatch(setOpenChatListModal(true));
    dispatch(setIsChatting(false));
    dispatch(setChatSelected({}));
  };

  const handleSelectConvention = (item: any) => {
    dispatch(setIsChatting(true));
    dispatch(setIsNewChatFormOtherScreen(false));
    dispatch(setChatSelected(item));
    if(item.main_staff && item.main_staff.id) {
      dispatch(setStaffSelected(item.main_staff));
    }

    if(item?.job && item?.job.id) {
      dispatch(setJobSelected(item?.job));
    } else {
      dispatch(setJobSelected({}));
    }
    
    if(!isOpenChatListModal || !isMobile) {
      dispatch(getTalentMessages({ id: item?.id }));

      let newChatList = JSON.parse(JSON.stringify(chatList));
      for(let itemChat of newChatList) {
        if(itemChat.id != item?.id) {
          continue
        }
        if(itemChat?.user_read && !itemChat?.user_read.includes(talentInfo.user_id)) {
          itemChat?.user_read?.push(talentInfo.user_id)
          break
        }
      }
      dispatch(setChatList(newChatList));
    }
  };


  const setNewChat = () => {
    setIsFirstLoad(true)
    dispatch(setIsChatting(true));
    dispatch(setIsNewChatFormOtherScreen(false));
    dispatch(setIsScout(false));
    dispatch(setStaffSelected({}));
    dispatch(setChatSelected({}));
    dispatch(setJobSelected({}));
    dispatch(setMessages([]));
    dispatch(setOpenChatListModal(false));
  }

  return (
    <>
      <TalentHeader
        productNameMob={"メッセージ"}
        button={isOpenChatListModal && <CustomButton variant="outline" size="sm" onClick={() => setNewChat()}>新規メッセージ</CustomButton>}
        startIcon={!isOpenChatListModal && {
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M15.4102 16.59L10.8302 12L15.4102 7.41L14.0002 6L8.00016 12L14.0002 18L15.4102 16.59Z"
                fill="#808080"
              />
            </svg>
          ),
          onClick: () => {
            handleCloseChatBox();
          },
        }}
      />
      <div className="px-0 md:mt-4 md:px-2 xl:mt-6 xl:px-6 flex xl:gap-6 md:gap-3 relative">
        <TalentSideMenu/>
        <div className="flex-1 flex h-[calc(100dvh-105px)] overflow-hidden gap-1">
          <div className={`${isOpenChatListModal ? "min-w-full" : "w-auto"} sm:min-w-auto md:min-w-[320px] lg:min-w-[380px] xl:min-w-[450px] max-h-full`}>
            <div className="hidden md:flex items-center mb-4">
              <h1
                className="text-base lg:text-xl font-bold leading-[1.875rem] alu-text-base-2 mr-4 lg:mr-8">
                メッセージ
              </h1>
              <button
                disabled={isChatting && !chatSelected.id}
                onClick={setNewChat}
                type="button"
                className="mr-2 w-auto border text-sm lg:text-sm border-[#FF861A] font-bold bg-alu-primary text-white py-1 px-2 lg:py-2 lg:px-6 rounded hover:bg-[#ea6d00] disabled:border-[#BBB] disabled:bg-[#BBB]"
              >
                新規メッセージ
              </button>
            </div>

            <div
              ref={divRef}
              className={`${isOpenChatListModal && chatList?.length > 0 ? "block" : "hidden"
              } md:block bg-white px-2 py-2 w-full rounded-l-lg max-h-full md:h-[calc(100dvh-200px)] overflow-y-auto overflow-x-hidden custom-scrollbar`}
            >
              <ChatList />
            </div>
          </div>
          <div
            className={`${!isOpenChatListModal ? "block" : "hidden"
            } md:block overflow-hidden w-full md:w-full md:max-h-[calc(100dvh-145px)]`}
          >
            <ChatBox />
          </div>
        </div>
      </div>
      <div className="hidden md:block -mt-10">
        <Copyright view="talent" />
      </div>
    </>
  );
};

export default TalentChat;